export default __webpack_public_path__ + "static/media/E2.a82b7668.svg";